import { FC, useCallback, useEffect, useState } from "react"
import HighCharts from "highcharts/highstock";
import { eachDayOfInterval, format, parse } from "date-fns";
import HighchartsReact from 'highcharts-react-official'

import { LINE_CHART } from "src/constants/highCharts";
import { COLOR_LIST } from "src/constants/cases";

import { LineChartProps } from "./types";
import { isMobile } from "src/helpers";





const CustomLineChart: FC<LineChartProps> = ({ LineChartObject ,title }): JSX.Element => {
  const [lineChart, setLineChart] = useState(LINE_CHART);



  const populateLineBase = () => {
    let allDates: any[] = [];
    LineChartObject?.forEach((caseVolume: any) => {
      allDates = allDates.concat(Object.keys(caseVolume.data));
    });
    const sortedDates = Array
      .from(new Set(allDates))
      .map((item) => parse(item, "yyyy-MM-dd", new Date()))
      .sort((a: Date, b: Date) => (a < b) ? -1 : 1)

    const allDateArr = eachDayOfInterval({ start: sortedDates[0], end: sortedDates[sortedDates.length - 1] })
    console.log("AL Date Array", allDateArr.length, allDateArr)
    return {
      data: allDateArr,
      step: isMobile() ? (allDateArr.length > 300 ? 1 : (allDateArr.length > 90 ? 30 : 7)) : (allDateArr.length > 250 ? 30 : (allDateArr.length < 55 ? (allDateArr.length < 20 ? 1 : 2) : 30))
    }
  }

  // Map data to the line series, filling missing dates with null
  const wrapperFunctionForLine = () => {
    let lineSeriesArray: any = [];
    const xAxisDates = populateLineBase().data; // Get the unique x-axis dates

    LineChartObject?.forEach((caseVolume,index) => {
      let seriesData: (number | null)[] = [];

      // Map over the xAxisDates, inserting data or null if missing
      xAxisDates.forEach((date) => {
        if (caseVolume.data) {
          const formattedDate = format(date, "yyyy-MM-dd");
          if (caseVolume.data[formattedDate] !== undefined) seriesData.push(caseVolume.data[formattedDate])
          else seriesData.push(null)
        }
      });

      lineSeriesArray.push({
        type: "spline",
        name: ["Received", "Completed"].includes(caseVolume.name) ? `Total ${caseVolume.name}` : caseVolume.name,
        data: seriesData,
        color: COLOR_LIST[index],
        boostThreshold: 0,
      });
    });

    return lineSeriesArray;
  };




  // Populate line chart options with x-axis and series data
  const populateLineChart = useCallback(() => {
    const lineOptions = { ...lineChart };
    lineOptions.series = wrapperFunctionForLine();
    const { data, step } = populateLineBase()

    lineOptions.xAxis = {
      categories: data.map((item) => format(item, "d. MMM")),
      labels: {
        step,
        rotation: isMobile() ? -45 : 0,
      },
    };
    setLineChart(lineOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LineChartObject]);

  useEffect(() => {
    populateLineChart();
  }, [populateLineChart]);




  return (
    <div className="card">
      <div className="card-header ">
        <h4 className="text-center m-0">{title}</h4>
      </div>
      <div className="card-body">
        <p className="text-center">Line convergence is positive, and higher numbers are better.</p>
        <HighchartsReact highcharts={HighCharts} options={lineChart} />
      </div>
    </div>
  )
}
export default CustomLineChart;
